/* eslint-disable */
import { useQuery } from '@tanstack/react-query';
import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';

import { rallitFetcher } from '../Fetcher';
import type { RequestOptions } from '../Fetcher';
const fetcher = rallitFetcher;

export type Maybe<T> = T | null;

export type OneOf<T> = T extends unknown[]
  ? T[number]
  : T extends readonly unknown[]
    ? T[number]
    : T;

export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]-?: Exclude<T[K], undefined>;
};

export type Values<T extends Record<string, unknown>> = T extends Record<string, infer U>
  ? U
  : T extends { [key: string]: infer U }
    ? U
    : never;

export const enum ResponseStatus {
  OK = 'OK',
  SERVER_ERROR = 'SERVER_ERROR',
  DUPLICATE = 'DUPLICATE',
  NOT_FOUND = 'NOT_FOUND',
  BAD_REQUEST = 'BAD_REQUEST',
  BAD_PARAMETER = 'BAD_PARAMETER',
  CONFLICT = 'CONFLICT',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
}

export type Success<T = unknown> = {
  statusCode: ResponseStatus.OK;
  message: '';
  data: T;
};

export type Error = {
  statusCode: Omit<keyof typeof ResponseStatus, 'OK'>;
  message: string;
  data: Maybe<''>;
};

/**
 * @typeParam T - Response data type
 */
export type ApiResponse<T = unknown> = Success<T>;

export const API_ENDPOINT = {
  CLIENT_V1_RESUME_HUB_SUMMARY: '/client/api/v1/resume-hub/summary',
} as const;

export const fetchClientApiV1ResumeHubSummary = async (
  url: string,
  requestOptions?: RequestOptions,
) => fetcher.get<ClientApiV1ResumeHubSummaryResponse>(url, requestOptions);

export function useClientApiV1ResumeHubSummaryQuery({
  queryKey,
  url,
  options,
  requestOptions,
}: {
  queryKey: QueryKey;
  url: string;
  options?: Omit<
    UseQueryOptions<ClientApiV1ResumeHubSummaryResponse, unknown>,
    'queryKey' | 'queryFn'
  >;
  requestOptions?: RequestOptions;
}) {
  const result = useQuery<ClientApiV1ResumeHubSummaryResponse, unknown>(
    queryKey,
    () => fetchClientApiV1ResumeHubSummary(url, requestOptions),
    options,
  );

  return { ...result, data: result.data?.data };
}

/**
 * created by ResponseSchemaGenerator
 */

export interface ClientApiV1ResumeHubSummary {
  data: Maybe<ResumeHubB2CSummaryResponse>;
}
export interface ResumeHubB2CSummaryResponse {
  /**
   * 프로필 허브 ID(랠릿 job_seeker.id)
   */
  hubId: number;
  /**
   * 직업
   */
  job: string;
  /**
   * 커리어 상태. 없는 경우 빈 문자열로 응답
   */
  careerStatus: string;
  /**
   * 프로필 이미지 cdn 주소
   */
  profileImage?: string;
}
export type ClientApiV1ResumeHubSummaryResponse = ApiResponse<ClientApiV1ResumeHubSummary['data']>;

/**
 * created by DTOGenerator
 */

export interface ClientApiV1ResumeHubSummaryQueryString {
  accountId: number;
}
